import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../_services/index';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
    currentYear: number = 2018;

    constructor(private _authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        this.currentYear = (new Date()).getFullYear();
        this.isLoggedIn();
    }

    isLoggedIn(): boolean {

        return this._authenticationService.isLoggedIn();

    }

}



// WEBPACK FOOTER //
// ./public/app/common/footer/footer.component.ts